import { useQuery, type QueryClient } from '@tanstack/react-query';
import type { Huddle } from '@avslack/shared';
import { listHuddles } from '../lib/api';

export const huddlesKey = ['huddles'] as const;

/**
 * Az elo huddle-k a sajat csatornaimban.
 *
 * A lista forrasa mindig a SZERVER: minden esemeny a teljes allapotot hozza,
 * nem kulonbseget. Egy elveszett esemeny igy legfeljebb egy pillanatig latszik,
 * a kovetkezo helyreallitja - nem tud tartos "ki van bent?" elteres kialakulni.
 */
export function useActiveHuddles() {
  return useQuery({ queryKey: huddlesKey, queryFn: listHuddles, staleTime: 15_000 });
}

export function upsertHuddle(queryClient: QueryClient, huddle: Huddle): void {
  queryClient.setQueryData<Huddle[]>(huddlesKey, (current) => {
    const rest = (current ?? []).filter((h) => h.id !== huddle.id);
    return [...rest, huddle];
  });
}

export function removeHuddle(queryClient: QueryClient, huddleId: string): void {
  queryClient.setQueryData<Huddle[]>(huddlesKey, (current) =>
    (current ?? []).filter((h) => h.id !== huddleId),
  );
}

export function findChannelHuddle(huddles: Huddle[] | undefined, channelId: string): Huddle | null {
  return huddles?.find((h) => h.channelId === channelId) ?? null;
}
